export const hasAdminLevel = () => {
  try {
    const adminLevelData = localStorage.getItem('adminLevel');
    if (adminLevelData) {
      const adminLevel = JSON.parse(adminLevelData);
      return adminLevel && (adminLevel.modules?.length > 0 || adminLevel.adminLevelId);
    }
  } catch (e) {
    console.error('Error checking admin level:', e);
  }
  return false;
};

export const createAvatar = (name) => {
  if (!name) return "UN";
  const parts = name.split(" ");
  return ((parts[0]?.[0] || "") + (parts[1]?.[0] || "")).toUpperCase();
};
